<template>

<div class="coin" :style="{backgroundImage: isMob ? null : 'url(/assets/boomx/images/coin-bg.jpg)'}">
		<div class="coin__steps">
			<div class="game-step no-scrollbar" ref="steps">
				<swiper class="game-step__slider"
					:slidesPerView="'auto'"
					:space-between="12"
					@swiper="onSwiper"
					:grab-cursor="true"
				>
					<swiper-slide class="game-step__slide" v-for="(item, key) in 12">
						<div class="game-step__item" :id="item" :class="[key == step && game ? 'active' : '', key < step ? 'success' :  '']">
							<div class="game-step__item-num">{{ key + 1 }}</div>
							<div class="game-step__item-body">
								<div class="game-step__item-title">{{ Number(coefs[key]) * bet }}</div>
								<div class="game-step__item-text">x{{ Number(coefs[key]) }}</div>
							</div>
						</div>
					</swiper-slide>
				</swiper>
			</div>
		</div>
		<div class="coin__view">
			<div id="coin" :class="[drop]">
				<div class="coin__side" :class="side1">
					<svg class="coin__side-icon">
						<use :href="`#svg-icon-${side1 === 'side-a' ? 'tails' : 'eagle'}`"></use>
					</svg>
				</div>
				<div class="coin__side" :class="side2">
					<svg class="coin__side-icon">
						<use :href="`#svg-icon-${side1 === 'side-a' ? 'eagle' : 'tails'}`"></use>
					</svg>
				</div>
			</div>
		</div>
		<div class="coin__control game-controls" :class="[game ? 'disabled opacity-5' : '']">
			<button class="game-controls__item" @click="typeBet('min')" type="button">Мин</button>
			<button class="game-controls__item" @click="typeBet('/2')" type="button">÷2</button>
			<div class="game-controls__bet">
				<div class="game-controls__bet-value">
					<div class="game-controls__bet-value-wrap">
						<div class="game-controls__bet-value-plug">{{bet}}</div>
						<input class="game-controls__bet-value-input"
							type="number"
							v-model="bet"
							@keyup="validateBet"
							autocomplete="off"
							:disabled="(game.active || disableBtn)"
						>
					</div>₽
				</div>
				<div class="game-controls__bet-label">Ставка</div>
			</div>
			<button class="game-controls__item" @click="typeBet('x2')" type="button">×2</button>
			<button class="game-controls__item" @click="typeBet('max')" type="button">Макс</button>
		</div>

		<div class="coin__actions">
			<button class="coin__action" @click="coinBet(0)" :disabled="disableBtnGame" type="button">
				<svg class="coin__action-icon">
					<use href="#svg-icon-eagle"></use>
				</svg>
				<span class="coin__action-text">Орел</span>
			</button>
			<button class="coin__action" @click="coinBet(1)" :disabled="disableBtnGame" type="button">
				<span class="coin__action-text">Решка</span>
				<svg class="coin__action-icon">
					<use href="#svg-icon-tails"></use>
				</svg>
			</button>
		</div>

		<div class="coin__buttons">
			<div class="coin__button" v-show="!game">
				<button class="btn btn--block coin__button" @click="startCoin()" :disabled="disableBtn">
					Начать игру
				</button>
			</div>

			<div class="coin__button" v-show="game">
				<button class="btn btn--block btn--success" @click="finishCoin();" :disabled="disableBtn || !step">
					Забрать {{ $root.currency(win) }}
				</button>
			</div>

			<div v-show="error" class="btn btn--block btn--red">
				{{ error }}
			</div>
		</div>
</div>
</template>

<script>
	import breakpointsMixin from "../../mixins/breakpoints-mixin.vue";
	import {mapState} from "pinia";
	import {useUserStore} from "../../stores/User.js";
	import { Swiper, SwiperSlide } from 'swiper/vue';

	const COIN_BASE_COEF = 1.8;
     
export default {

	components: {
		Swiper,
		SwiperSlide,
	},

	mixins: [
		breakpointsMixin
	],

	data() {
		return {
			currentStepX: 1,
			slideStep: 1,
			game: false,
			bet: 1,
			coef: COIN_BASE_COEF,
			win: 0,
			step: 0,
			drop: 'noDrop',
			nextcoef: 3.6,
			error: false,
			disableBtn: false,
			disableBtnGame: true,
			currentStep: 1,
			side1: 'side-a',
			side2: 'side-b',
			coefs: [],
			swiper: null
		}
	},
	mounted() {
		this.$root.isLoading = true;

		if (this.$cookie.get('token')) {
			this.getGame();
		} else {
			this.$root.isLoading = false;
		}

		for (let i = 1; i < 13; i++) {
			this.coefs.push((COIN_BASE_COEF * i));
		}
	},

	watch: {
		step() {
			this.scrollToActiveStep();
		},

		game(state) {
			if(!state) {
				this.disableBtnGame = true;
			}
		}
	},

	computed: {
		...mapState(useUserStore, ['user']),
	},

	methods: {
		startCoin() {
			this.drop = 'noDrop';
			this.error  = false;

			if (! this.$cookie.get('token')) {
				this.error = 'Авторизуйтесь';

				this.disableBtn = false;

				return;
			}

			this.bet = this.bet.toString();

			this.bet = this.bet.replace(/[,]/g, '.').replace(/[^\d,.]*/g, '').replace(/([,.])[,.]+/g, '$1').replace(/^[^\d]*(\d+([.,]\d{0,2})?).*$/g, '$1');
			this.bet = parseInt(this.bet, 10);

			this.$root.axios.post('/api/game/coin/start', {
				bet: this.bet
			}).then(res => {
				const data = res.data;

				this.coef = COIN_BASE_COEF;
				this.nextcoef = COIN_BASE_COEF * 2;
				this.game = true;
				this.step = 0;
				this.win = Number(data.bet).toFixed(2);
				this.user.balance = data.balance;
				this.disableBtnGame = false;
			}).catch(error => {
				this.error = this.$root.graphql.axiosGetError(error)
				this.disableBtn = false;
			});
		},
		finishCoin() {
			this.disableBtnGame = true;
			this.drop = 'noDrop';
			this.error  = false;
			this.bet = parseInt(this.bet, 10);

			this.$root.axios.post('/api/game/coin/finish').then(res => {
				const data = res.data;

				this.user.balance = data.balance;
				this.game = false;
				this.win = 0;
				this.step = 0;

				this.disableBtn = false;
			}).catch(error => {
				this.errors = {
					show: true,
					message: this.$root.graphql.axiosGetError(error)
				};

				this.disableBtn = false;
			});
		},
		getGame() {
			this.axios.get('/api/game/coin/info')
			.then(res => {
				const data = res.data;

				if(data.success) {
					this.disableBtnGame = false;

					let coef = !data.step ? 1 : data.coef;
					this.game = true;
					this.bet = data.bet;
					this.win = Number(coef * data.bet).toFixed(2);
					this.coef = data.coef;
					this.nextcoef = data.nextcoef;
					this.step = data.step;
				}
			}).catch(error => {
				this.error = this.$root.graphql.axiosGetError(error);
			});

			this.$root.isLoading = false;
		},
		getSides() {
			var t, e;
			return 1 === this.currentStep - 1
				? (t = "side-b", e = "side-a")
				: 0 === this.currentStep - 1 && (t = "side-a", e = "side-b"), [t, e]
		},
		coinBet(type) {
			if (this.disableBtnGame) {
				return;
			}

			this.disableBtnGame = true;

			this.error = false;

			this.$root.axios.post('/api/game/coin/choose', {
				side: type
			}).then(res => {
				const data = res.data;

				this.disableBtn = true;
				this.currentStep = (data.drop == 1) ? 1 : 2;

				var t = this,
					e = document.querySelector('#coin'),
					o = this.getSides(),
					//n = O()(o, 2),
					r = o[0],
					l = o[1];

				e.classList.add("animate"), setTimeout((function () {
					t.side1 = r, t.side2 = l
				}), 300);

				e.addEventListener("animationend", (function o() {
					e.classList.remove("animate");
					e.removeEventListener("animationend", o);
					t.disableBtn = false;
					t.win = Number(data.bet * data.coef).toFixed(2);
					t.coef = data.coef;
					t.nextcoef = data.nextcoef;
					t.step++;
					if (data.nextcoef == 0) {
						t.game = false;
						t.coef = COIN_BASE_COEF;
						t.nextcoef = COIN_BASE_COEF * 2;
						t.step = 0;
					}
					t.disableBtnGame = false;
				}));
			}).catch(error => {
				this.error = this.$root.graphql.axiosGetError(error);
			});
		},
		typeBet(type) {
			switch (type) {
				case "max":
					if (this.user !== null) {
						this.bet = this.user.balance > 1000000 ? 1000000 : this.bet;
					} else {
						this.bet = 0;
					}
					break;
				case "min":
					this.bet = 1;
					break;
				case "x2":
					this.bet = this?.user?.balance && this.bet * 2 > +this.user.balance ? this.user.balance : +(this.bet * 2).toFixed(2);
					break;
				case "/2":
					this.bet = (this.bet / 2).toFixed(2);
					break;
			}
			this.validateBet();
		},
		validateBet() {
			if(Number(this.bet) && this.bet < 1) {
				this.bet = 1;
			}
			if (this.bet > 1000000) {
				this.bet = 1000000;
			}
			if (this?.user?.balance && this.bet > +this.user.balance) {
				this.bet = +this.user.balance
			}
		},
		scrollToActiveStep() {
			this.swiper.slideTo(this.step - 1);
		},

		onSwiper(inst) {
			this.swiper = inst;
			setTimeout(() => this.swiper.update(), 0);
		},
	}
}
</script>